module.exports = __webpack_public_path__ + "img/icon_guanyuwomen_guoji@3x.eb5da1c7.png";